// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__c0AsZ","loadingContainer":"styles_loadingContainer__5cqyT"};